import "@css/app.css";

/* JS */
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "./form";

Fancybox.bind("[data-fancybox]");

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;

document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");
  megaMenus.forEach((menu) => {
    setTimeout(() => {
      menu.classList.add("is-loaded");
    }, 1000);
  });
});

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

window.appHeight = appHeight;

const header = document.querySelector(".site-header");

// Header scroll configuration
const HEADER_SCROLL_CONFIG = {
  threshold: 200, // Pixels to scroll before triggering
  debounceDelay: 1, // Milliseconds to wait between scroll events
};

// Header height configuration
const HEADER_HEIGHT_CONFIG = {
  desktop: {
    expanded: 192, // Base height when not scrolled
    collapsed: 73, // Height when scrolled down
  },
  mobile: {
    expanded: 120, // Base height for mobile
    collapsed: 73, // Height when scrolled down
  },
};

let scrollTimeout;
let lastScrollY = 0;

// Calculate the total height of active alert/notification bars
function getActiveAlertBarsHeight() {
  const alertBar = document.querySelector(".alert-bar");
  const notificationBar = document.querySelector(".notification-bar");

  let totalHeight = 0;

  // Helper function to check if element is truly visible
  function isElementVisible(element) {
    if (!element) return false;

    // Check if element exists and has height
    if (element.offsetHeight === 0) return false;

    // Check if display is not none
    if (element.style.display === "none") return false;

    // Check if element is not hidden by Alpine.js
    if (element.hasAttribute("x-show") && element.style.display === "none")
      return false;

    // Check if element is not hidden by CSS
    const computedStyle = window.getComputedStyle(element);
    if (
      computedStyle.display === "none" ||
      computedStyle.visibility === "hidden"
    )
      return false;

    return true;
  }

  // Check if alert bar is visible and measure its actual height
  if (isElementVisible(alertBar)) {
    totalHeight += alertBar.offsetHeight;
  }

  // Check if notification bar is visible and measure its actual height
  if (isElementVisible(notificationBar)) {
    totalHeight += notificationBar.offsetHeight;
  }

  return totalHeight;
}

// Update header height based on current state and active alert bars
function updateHeaderHeight() {
  if (!header) return;

  const isDesktop = window.innerWidth >= 1024;
  const isScrolledDown = header.classList.contains("scrolled-down");
  const alertBarsHeight = getActiveAlertBarsHeight();

  let baseHeight, targetHeight;

  if (isDesktop) {
    baseHeight = isScrolledDown
      ? HEADER_HEIGHT_CONFIG.desktop.collapsed
      : HEADER_HEIGHT_CONFIG.desktop.expanded;
  } else {
    baseHeight = isScrolledDown
      ? HEADER_HEIGHT_CONFIG.mobile.collapsed
      : HEADER_HEIGHT_CONFIG.mobile.expanded;
  }

  // Add alert bars height to the base height
  targetHeight = baseHeight + alertBarsHeight;

  // Apply the calculated height to header
  header.style.height = `${targetHeight}px`;
  header.style.minHeight = `${targetHeight}px`;
  header.style.maxHeight = `${targetHeight}px`;

  // Update main content margin-top to match header height
  const mainElement = document.querySelector("main");
  if (mainElement) {
    mainElement.style.marginTop = `${targetHeight}px`;
  }

  // Debug logging (remove in production)
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("ddev.site")
  ) {
    const alertBar = document.querySelector(".alert-bar");
    const notificationBar = document.querySelector(".notification-bar");

    /*console.log("Header and main margin updated:", {
      isDesktop,
      isScrolledDown,
      alertBarsHeight,
      baseHeight,
      targetHeight,
      alertBarHeight: alertBar ? alertBar.offsetHeight : 0,
      notificationBarHeight: notificationBar ? notificationBar.offsetHeight : 0,
    });*/
  }
}

function handleHeaderScroll() {
  if (!header) return;

  const isDesktop = window.innerWidth >= 1024;
  const currentScrollY = window.scrollY;

  // Clear existing timeout
  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
  }

  // Debounce the scroll event
  scrollTimeout = setTimeout(() => {
    if (isDesktop) {
      const hasScrolledPastThreshold =
        currentScrollY > HEADER_SCROLL_CONFIG.threshold;
      const isAtTop = currentScrollY <= HEADER_SCROLL_CONFIG.threshold;

      if (
        hasScrolledPastThreshold &&
        !header.classList.contains("scrolled-down")
      ) {
        header.classList.add("scrolled-down");
      } else if (isAtTop && header.classList.contains("scrolled-down")) {
        header.classList.remove("scrolled-down");
      }
    } else {
      // On mobile, always remove scrolled-down
      header.classList.remove("scrolled-down");
    }

    // Update header height after scroll state changes
    updateHeaderHeight();

    lastScrollY = currentScrollY;
  }, HEADER_SCROLL_CONFIG.debounceDelay);
}

// Remove old scroll logic variables and listeners
window.addEventListener("scroll", handleHeaderScroll, { passive: true });
window.addEventListener(
  "resize",
  () => {
    handleHeaderScroll();
    // Add a small delay to allow for text reflow before updating height
    setTimeout(() => {
      updateHeaderHeight();
    }, 100);
  },
  { passive: true }
);

// Scroll lock for mega menus
let megaMenuScrollLocked = false;

function handleMegaMenuScrollLock() {
  const primaryNavItems = document.querySelectorAll(
    ".site-header__nav-ul > li"
  );

  primaryNavItems.forEach((item) => {
    const megaMenu = item.querySelector(".mega-menu");

    if (megaMenu) {
      // Mouse enter - lock scroll
      item.addEventListener("mouseenter", () => {
        if (!megaMenuScrollLocked) {
          try {
            disableBodyScroll(document.body);
            megaMenuScrollLocked = true;
          } catch (error) {
            /*console.warn("Failed to lock scroll for mega menu:", error);*/
          }
        }
      });

      // Mouse leave - unlock scroll
      item.addEventListener("mouseleave", () => {
        if (megaMenuScrollLocked) {
          try {
            enableBodyScroll(document.body);
            megaMenuScrollLocked = false;
          } catch (error) {
            /*console.warn("Failed to unlock scroll for mega menu:", error);*/
          }
        }
      });

      // Focus in - lock scroll
      item.addEventListener("focusin", () => {
        if (!megaMenuScrollLocked) {
          try {
            disableBodyScroll(document.body);
            megaMenuScrollLocked = true;
          } catch (error) {
            /*console.warn("Failed to lock scroll for mega menu:", error);*/
          }
        }
      });

      // Focus out - unlock scroll
      item.addEventListener("focusout", (e) => {
        // Check if focus is moving to another element within the same nav item
        setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            if (megaMenuScrollLocked) {
              try {
                enableBodyScroll(document.body);
                megaMenuScrollLocked = false;
              } catch (error) {
                /*console.warn("Failed to unlock scroll for mega menu:", error);*/
              }
            }
          }
        }, 100);
      });
    }
  });
}

// Initialize mega menu scroll lock
document.addEventListener("DOMContentLoaded", () => {
  handleMegaMenuScrollLock();

  // Initialize header state on page load
  const header = document.querySelector(".site-header");
  if (header) {
    const isDesktop = window.innerWidth >= 1024;
    // If on mobile, ensure scrolled-down class is not present
    if (!isDesktop && header.classList.contains("scrolled-down")) {
      header.classList.remove("scrolled-down");
    }

    // Initialize header height
    updateHeaderHeight();

    // Set up observers for alert bar visibility changes
    setupAlertBarObservers();

    // Watch for dynamically injected alert bars (from Blitz dynamic includes)
    setupDynamicAlertBarWatcher();
  }
});

// Set up observers to watch for alert bar visibility changes
function setupAlertBarObservers() {
  const alertBar = document.querySelector(".alert-bar");
  const notificationBar = document.querySelector(".notification-bar");

  // Create a MutationObserver to watch for style changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "style"
      ) {
        // Small delay to ensure Alpine.js has finished updating
        setTimeout(() => {
          updateHeaderHeight();
        }, 10);
      }
    });
  });

  // Create a ResizeObserver to watch for size changes (text wrapping, etc.)
  const resizeObserver = new ResizeObserver((entries) => {
    // Debounce resize events
    clearTimeout(resizeObserver.timeout);
    resizeObserver.timeout = setTimeout(() => {
      updateHeaderHeight();
    }, 50);
  });

  // Observe alert bar if it exists
  if (alertBar) {
    observer.observe(alertBar, {
      attributes: true,
      attributeFilter: ["style"],
    });
    resizeObserver.observe(alertBar);
  }

  // Observe notification bar if it exists
  if (notificationBar) {
    observer.observe(notificationBar, {
      attributes: true,
      attributeFilter: ["style"],
    });
    resizeObserver.observe(notificationBar);
  }
}

// Watch for dynamically injected alert bars (e.g., from Blitz dynamic includes)
function setupDynamicAlertBarWatcher() {
  const header = document.querySelector(".site-header");
  if (!header) return;

  // Track which elements we've already set up observers for
  const observedElements = new WeakSet();

  const domObserver = new MutationObserver((mutations) => {
    let foundNewAlertBar = false;

    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is an alert/notification bar
            if (
              (node.classList?.contains("alert-bar") ||
                node.classList?.contains("notification-bar")) &&
              !observedElements.has(node)
            ) {
              foundNewAlertBar = true;
              observedElements.add(node);
            }
            // Also check children of added nodes (for wrapper elements)
            const alertBars = node.querySelectorAll?.(".alert-bar, .notification-bar");
            alertBars?.forEach((bar) => {
              if (!observedElements.has(bar)) {
                foundNewAlertBar = true;
                observedElements.add(bar);
              }
            });
          }
        });
      }
    });

    if (foundNewAlertBar) {
      // Re-setup observers for the new elements and update height
      setupAlertBarObservers();
      // Small delay to let Alpine.js initialize the x-show directive
      setTimeout(() => {
        updateHeaderHeight();
      }, 50);
    }
  });

  // Watch the header and its subtree for new elements
  domObserver.observe(header, {
    childList: true,
    subtree: true,
  });
}

var scrollLockEnabled = false;
let theNav = document.querySelector(".mobile-nav");
function shouldScrollLock() {
  if (!scrollLockEnabled) {
    disableBodyScroll(theNav);
  } else {
    enableBodyScroll(theNav);
  }
  scrollLockEnabled = !scrollLockEnabled;
}

window.shouldScrollLock = shouldScrollLock;

// Global function to update header height (can be called from Alpine.js)
window.updateHeaderHeight = updateHeaderHeight;

// end header scroll effect

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import Swiper from "swiper";
import { Pagination, Navigation, EffectFade, Autoplay } from "swiper/modules";

Array.from(document.querySelectorAll(".js-slider-banner")).forEach(
  (container) => {
    const slider = container.querySelector(".swiper");
    const pagination = container.querySelector(".swiper-pagination");

    const swiper = new Swiper(slider, {
      modules: [Pagination, EffectFade, Autoplay],
      loop: true,
      autoHeight: false,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      autoplay: {
        delay: 8000,
      },
    });
  }
);

Array.from(document.querySelectorAll(".js-slider-testimonials")).forEach(
  (container) => {
    const slider = container.querySelector(".swiper-testimonials");
    const pagination = container.querySelector(".swiper-pagination");
    const navigation = container.querySelector(".swiper-buttons");

    const swiperTestimonials = new Swiper(slider, {
      modules: [Pagination, Navigation, EffectFade, Autoplay],
      loop: true,
      autoHeight: false,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      autoplay: {
        delay: 8000,
      },
    });
  }
);

Array.from(document.querySelectorAll(".js-slider-cards")).forEach(
  (container) => {
    const slider = container.querySelector(".swiper");
    const pagination = container.querySelector(".swiper-pagination");

    const swiper = new Swiper(slider, {
      modules: [Pagination, EffectFade, Autoplay],
      loop: true,
      autoHeight: false,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      autoplay: {
        delay: 8000,
      },
    });
  }
);

import $ from "jquery";
import "bootstrap/js/dist/modal";

function init() {
  /* speedbump */
  $.expr[":"].external = function (a) {
    var linkhn = a.hostname.split(".").reverse();
    var linkHref = linkhn[1] + "." + linkhn[0];
    var domainhn = window.location.hostname.split(".").reverse();
    var domainHref = domainhn[1] + "." + domainhn[0];
    return (
      !a.href.match(/^mailto\:/) &&
      !a.href.match(/^tel\:/) &&
      linkHref !== domainHref &&
      a.href.match(/^http/)
    );
  };
  $("a:external").addClass("ext_link");
  $(function () {
    $("a.ext_link:not(.not_ext)").click(function () {
      // open a modal
      $("#leavingSiteModal").modal();
      $("a:external").attr("data-toggle", "modal");
      $("a:external").attr("data-target", "#speedbump");
      //go to link on modal close
      var url = $(this).attr("href");
      $(".btn-modal.btn-continue").click(function () {
        window.open(url);
        $(".btn-modal.btn-continue").off();
        $("#leavingSiteModal").modal("hide");
      });
      $(".btn-modal.btn-close").click(function () {
        $("#leavingSiteModal").modal("hide");
        $(".btn-modal.btn-close").off();
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});

class InlineVideo {
  constructor(el) {
    this._el = el;
    this._video = el.dataset.video;
    this._image = el.querySelector(".js-video__placeholder");

    this._el.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    this._el.insertAdjacentHTML(
      "beforeend",
      `<iframe src="${this._video}?autoplay=1&rel=0" frameborder="0"></iframe>`
    );
    this._image.classList.add("fade-out");

    setTimeout(() => {
      this._image.remove();
    }, 700);

    this._el.removeEventListener("click", this.handleClick);
  }
}

Array.from(document.querySelectorAll(".js-video")).forEach((video) => {
  new InlineVideo(video);
});
